import ListGroup from 'react-bootstrap/ListGroup';
import React, { useState, useEffect, useRef } from "react";
import Container from 'react-bootstrap/Container';

function Home() {

  return (
    <Container fluid className="bg-light">
      <h1>Gym App: Get off your fat ass and train</h1>
      <div className='bg-light shadow-lg p-2 mb-4'>
        <div className="row">
          <div className='col-md-12'>
            <h4 className='m-4'>This is your workout for today:</h4>

            <div className="row">
              <div className='col-md-6'>
                <div className='bg-secondary text-white shadow m-4 p-2'>
                  Skip rope - 500 reps @ unweighted
                </div>
              </div>
              <div className='col-md-6'>
                <div className='bg-secondary text-white shadow m-4 p-2'>
                  Deadlift - 4 sets of 10 reps @ 40 kg
                </div>
              </div>
            </div>

            <div className="row">
              <div className='col-md-6'>
                <div className='bg-secondary text-white shadow m-4 p-2'>
                  Tricep cable pulldown - 4 sets of 25 reps @ 16 kg
                </div>
              </div>
              <div className='col-md-6'>
                <div className='bg-secondary text-white shadow m-4 p-2'>
                  Bent over rows - 3 sets of 10 reps @ 80 kg
                </div>
              </div>
            </div>

            <div className="row">
              <div className='col-md-6'>
                <div className='bg-secondary text-white shadow m-4 p-2'>
                  Hack squats - 4 sets of 8 reps
                </div>
              </div>
              <div className='col-md-6'>
                <div className='bg-secondary text-white shadow m-4 p-2'>
                  Weighted box jumps - 4 sets of 20 reps @ 35 kg
                </div>
              </div>
            </div>

            <div className="row">
              <div className='col-md-6'>
                <div className='bg-secondary text-white shadow m-4 p-2'>
                  Calf press - 3 sets of 12 reps @ 40 kg
                </div>
              </div>
              <div className='col-md-6 '>
                <div className='bg-secondary text-white shadow m-4 p-2'>
                  Face pulls- 3 sets of 8 reps @ 20 kg
                </div>
              </div>
            </div>

          </div>

        </div>
      </div>
    </Container>
  );
}

export default Home;